import { useTranslations } from 'next-intl';
import { CatTooltip } from 'blocks-nextjs/blocks-react/components/Tooltip';
import { CatButton } from 'blocks-nextjs/blocks-react/components/Button';
import ContactDealerPopoverContent from 'components/contact-your-dealer/contact-dealer-popover-content/contact-dealer-popover-content';
import styles from './contact-dealer-tooltip.module.scss';
import { usePartDiagram } from 'hooks/use-part-diagram/parts-diagram-context';

const ContactDealerTooltip = () => {
  const t = useTranslations();
  const { serverData } = usePartDiagram();
  return (
    <CatTooltip position="top-start" isInteractive>
      <CatButton
        variant="ghost"
        slot="trigger"
        className={styles['contact-dealer-btn']}
      >
        {t('CONTACT_YOUR_DEALER')}
      </CatButton>
      <ContactDealerPopoverContent
        dealerAddress={serverData?.dealerData?.address}
        locale={serverData?.locale}
      />
    </CatTooltip>
  );
};
export default ContactDealerTooltip;
